var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ui-icon-button',{staticStyle:{"vertical-align":"middle"},attrs:{"icon":"download","type":"secondary","tooltip":"Download"},on:{"click":_setup.downloadConversation}})
}
var staticRenderFns = []

export { render, staticRenderFns }